import { useEffect, useState } from "react";

/**
 * F-listas-cartoes (auditoria UX 23/10/2026, CEO 24/10: "comece pelas listas em
 * cartões no celular") — abaixo de 768 px as listas do ERP deixam a tabela
 * (que escondia 6 de 8 colunas atrás de rolagem lateral) e viram cartões.
 * Um hook só, com `matchMedia`, para todas as telas decidirem igual.
 */
export function useIsMobile(maxWidth = 767): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [mobile, setMobile] = useState<boolean>(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMobile(e.matches);
    setMobile(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return mobile;
}
